import { defineMessages } from 'react-intl';

export const messages: {
	readonly copyTooltip: {
		readonly id: 'rovo-chat.view-agent.copy-instructions-tooltip-label';
		readonly defaultMessage: 'Copy';
		readonly description: 'Label for copy tooltip';
	};
	readonly copiedTooltip: {
		readonly id: 'rovo-chat.view-agent.copied-instructions-tooltip-label';
		readonly defaultMessage: 'Copied';
		readonly description: 'Label for copied tooltip';
	};
} = defineMessages({
	copyTooltip: {
		id: 'rovo-chat.view-agent.copy-instructions-tooltip-label',
		defaultMessage: 'Copy',
		description: 'Label for copy tooltip',
	},
	copiedTooltip: {
		id: 'rovo-chat.view-agent.copied-instructions-tooltip-label',
		defaultMessage: 'Copied',
		description: 'Label for copied tooltip',
	},
} as const);
